import "./Login.css";
import { useState } from "react";
import profileImg from "./assets/robort.png";

export default function Login() {

  const [loggedIn, setLoggedIn] = useState(false);

  const handleLogin = () => {
    setLoggedIn(true); // fake login for now
  };

  return (
    <div className="login-page">

      {!loggedIn ? (

        <div className="login-card">

          <h2>Welcome Back 👋</h2>
          <p>Please login to continue</p>

          <input type="email" placeholder="Email Address" />
          <input type="password" placeholder="Password" />

          <button onClick={handleLogin}>Login</button>

        </div>

      ) : (

        <div className="profile-card">

          <img src={profileImg} alt="Profile" />

          <h2>Hi, Shifa 👋</h2>
          <p><b>Course:</b> Web Development</p>
          <p><b>Email:</b> shifa@email.com</p>
          <p><b>Progress:</b> 42%</p>

          <button>Go to Dashboard</button>

        </div>

      )}

    </div>
  );
}
